import { Partner } from 'app/api/@generated/backend';

class PartnerUtils {
    public static getPartnerById(partners: Partner[], partnerId: string): Partner | undefined {
        return partners.find((partner) => partner.id === partnerId);
    }
}

export { PartnerUtils };
